export default __webpack_public_path__ + "static/media/before@2x.4f7b7413.png";